import { render, staticRenderFns } from "./DayItem.vue?vue&type=template&id=0284acc5"
import script from "./DayItem.ts?vue&type=script&lang=ts&external"
export * from "./DayItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports